import React from 'react';
import Input from './Input';
import InputChangeWord from './InputChangeWord';
import Select from './Select';
import DatePicker from './DatePicker';
import Checkbox from './Checkbox';
import FormattedInput from './FormattedInput';

const FormInput = (props) => {
  let CurrentInput;
  let modifiedProps = props;

  switch (props.type) {
    case 'date':
    case 'year':
      CurrentInput = DatePicker;
      break;
    case 'select':
      CurrentInput = Select;
      break;
    case 'checkbox':
      CurrentInput = Checkbox;
      break;
    case 'textChangeWord':
      CurrentInput = InputChangeWord;
      break;
    case 'cell-phone': {
      CurrentInput = FormattedInput;
      // Add validation for exactly 10 digits only if field is not disabled or loading
      const cellPhoneValidation = (props.disabled || props.loading) ? 
        { ...props.validation } : 
        {
          ...props.validation,
          required: props.validation?.required || 'Cell phone is required',
          validate: {
            ...props.validation?.validate,
            exactLength: (value) => {
              // Skip validation if field is disabled or loading
              if (props.disabled || props.loading) {
                return true;
              }
              if (!value || value.length !== 10) {
                return 'El celular debe tener 10 dígitos';
              }
              return true;
            }
          }
        };
      modifiedProps = { 
        ...props, 
        register: undefined,
        validation: cellPhoneValidation
      };
      break;
    }
    case 'home-phone':
    case 'phone':
    case 'currency':
    case 'document':
      CurrentInput = FormattedInput;
      modifiedProps = { ...props, register: undefined };
      break;
    default:
      CurrentInput = Input;
      break;
  }

  const errors = modifiedProps.loading ? undefined : modifiedProps.errors;
  const showErrorMessage = modifiedProps.showErrorMessage ?? true;

  return (
    <div className={modifiedProps.className}>
      <CurrentInput 
        {...{ ...modifiedProps, errors }} 
      />
      {showErrorMessage && errors ? (
        <span className="mt-0.5 block px-3 text-xs text-error">
          *{errors.message}
        </span>
      ) : undefined}
    </div>
  );
};

export default FormInput;